import { css as e } from "@microsoft/fast-element";
import { normalize as t } from "../common/normalize.js";
import { display as i } from "@matrix42/fast-foundation";
import { typography as n } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
const g = (r) => e`
  ${t}
  ${i("flex")}
  :host {
    /* Typography */
    ${n("p", "regular")};

    height: ${o.spacing[14]};
    width: ${o.spacing[14]};
  }

  ::slotted(${r.prefix}-icon) {
    height: ${o.spacing[6]};
    width: ${o.spacing[6]};
  }

  .control {
    line-height: normal;
    color: ${o.color.neutral[100]};
    cursor: pointer;
    padding: ${o.spacing[4]};
    height: ${o.spacing[14]};
    width: ${o.spacing[14]};

    background: none;
    border: none;
  }

  .control:active,
  :host(.selected:enabled) .control {
    /* Style */
    color: ${o.color.primary[500]};
  }

  .control:hover:enabled {
    background-color: ${o.color.neutral[30]};
  }

  .control:active:enabled::after,
  .control:focus-visible::after,
  :host(.selected:enabled) .control::after {
    content: '';
    display: block;
    width: ${o.spacing[14]};
    height: ${o.spacing["0.5"]};
    background: linear-gradient(
      90deg,
      ${o.color.ai.purple} 0.07%,
      ${o.color.ai.teal} 100%
    );
    margin-top: ${o.spacing[4]};
    margin-left: calc(-1 * ${o.spacing[4]});
    position: fixed;
  }

  .control:disabled {
    /* Style */
    color: ${o.color.neutral[70]};
  }
`;
export {
  g as aiActionStyles
};
